"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _requiredSymbol = _interopRequireDefault(require("./required-symbol"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(props) {
  var layout = props.layout,
      label = props.label,
      htmlFor = props.htmlFor,
      labelClassName = props.labelClassName,
      fakeLabel = props.fakeLabel,
      required = props.required;

  if (layout === 'elementOnly') {
    return null;
  }

  var labelClassNames = (0, _dedupe.default)(['control-label', layout === 'horizontal' ? 'col-sm-3' : '', labelClassName]);

  if (fakeLabel) {
    return _react.default.createElement("div", {
      className: labelClassNames,
      "data-required": required
    }, _react.default.createElement("strong", null, label, _react.default.createElement(_requiredSymbol.default, {
      required: required
    })));
  }

  return _react.default.createElement("label", {
    className: labelClassNames,
    "data-required": required,
    htmlFor: htmlFor
  }, label, _react.default.createElement(_requiredSymbol.default, {
    required: required
  }));
};

Label.propTypes = {
  fakeLabel: _propTypes.default.bool,
  htmlFor: _propTypes.default.string,
  label: _propTypes.default.node,
  labelClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  layout: _propTypes.default.oneOf(['horizontal', 'vertical', 'elementOnly']),
  required: _propTypes.default.bool
};
Label.defaultProps = {
  fakeLabel: false,
  htmlFor: null,
  label: null,
  labelClassName: '',
  layout: 'horizontal',
  required: false
};
var _default = Label;
exports.default = _default;